import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        addIntegration(ctx, integrationData) {
            return new Promise((resolve, reject) => {
                let integration = integrationData.integrationData
                axios
                    .post('/api/integrations', integration)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchIntegrationAssetsSummary(ctx, { customerId, vendor }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/integrations/${vendor}/customers/${customerId}/assets-summary`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        searchIntegrations(ctx, {search, integration, customerId, page, perPage, expiredOnly}) {
            return new Promise((resolve, reject) => {
                const params = {
                    search: search,
                    customerId: customerId,
                    expiredOnly: expiredOnly,
                    Page: page,
                    PerPage: perPage,
                };
                if (integration) params.integration = integration
                axios
                    .get('/api/integrations/search', { params })
                    .then(response => resolve(response.data))
                    .catch(error => reject(error));
            });
        },
        fetchForceIntegrationAssetsSummary(ctx, { customerId, vendor }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/integrations/${vendor}/telemetry?customerId=${customerId}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
    }
}
